module.exports = __webpack_public_path__ + "static/media/DreamHouseLogo.423e8713.PNG";